import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Row } from '../server/layout/Row/index';
export function PanelHeader({ children, actions, padX = 'xl', padY = 'lg', }) {
    return (_jsxs(Row, { justify: "space-between", align: "center", style: {
            padding: `var(--space-${padY}) var(--space-${padX})`,
            borderBottom: '1px solid var(--border)',
        }, children: [_jsx(Row, { gap: "md", align: "center", children: children }), actions && _jsx(Row, { gap: "sm", children: actions })] }));
}
//# sourceMappingURL=PanelHeader.js.map